import { IPaginationDTO, IPaginationResponse } from '@/models/pagination.model';
import { IFullAddress } from '@/models/addresses.model';

export enum UsersEndpoints {
  USERS = '/users',
  USERS_LIST = '/users/list',
}

export enum UserStatus {
  ACTIVE = 'active',
  DEACTIVATED = 'deactivated',
}

// ----------------- DTOs ----------------

export interface IGetUsersListDTO extends Partial<IPaginationDTO> {
  status?: UserStatus;
  full_name?: string;
  email?: string;
  phone_number?: string;
  limit?: number;
  tripletex_customer_number?: string;
}

export interface IUpdateUserDTO {
  id?: string;
  email?: string;
  full_name?: string;
  phone_number?: string;
  status?: UserStatus;
  system_language?: string;
  address?: IFullAddress;
  invoice_address?: IFullAddress;
}

// ------------ Responses --------------

export interface IUser {
  PK: string;
  SK: string;
  created: string;
  modified: string;
  email: string;
  full_name: string;
  phone_number: string;
  status: UserStatus;
  system_language: string;
  last_login_at: string;
  tripletex_customer_number?: string;
  address: IFullAddress;
  invoice_address: IFullAddress;
}

export interface IUsersListResponse {
  items: IUser[];
  cursor: IPaginationResponse;
}
